import { mockedArticleContentMarkdown } from "../constants";
import { useArticles } from "./useArticles";

export const useDetailArticle = (id: number) => {
	const { handleSaveArticle, isSavedArticle } = useArticles();

	const menuIcons = [
		{
			icon: isSavedArticle(id) ? "bookmark" : "bookmark-outline",
			onPress: () => handleSaveArticle(id),
		},
		// {
		//   icon: 'information-outline',
		//   onPress: () => console.info('Information'),
		// },
		// {
		//   icon: 'dots-vertical',
		//   onPress: () => console.info('Dots'),
		// },
	];

	return {
		menuIcons,
		mockedArticleContentMarkdown,
	};
};
